window.GenderColumns = [
    {
        colName: 'rcdc',
        colTitle: 'RCDC Category',
        dataField: 'rcdcCategory',
        type: 'string',
        display: false
    },
    {
        colName: 'institute',
        colTitle: 'Institute/Center',
        dataField: 'ic',
        type: 'string',
        display: false
    },
    {
        colName: 'study-population',
        colTitle: '',
        dataField: 'studyPopulation',
        type: 'string',
        display: false
    },
    {
        colName: 'total',
        colTitle: 'Total Participants',
        dataField: 'totalGenderParticipants',
        type: 'number'
    },
    {
        colName: 'female',
        colTitle: 'Female Participants',
        dataField: 'female',
        type: 'number'
    },
    {
        colName: 'perc-female',
        colTitle: '% Female Participants',
        dataField: 'femalePercent',
        type: 'percent'
    },
    {
        colName: 'median-perc-female',
        colTitle: 'Median % Female Participants',
        dataField: 'femaleMedianPercent',
        type: 'percent'
    },
    {
        colName: 'male',
        colTitle: 'Male Participants',
        dataField: 'male',
        type: 'number'
    },
    {
        colName: 'perc-male',
        colTitle: '% Male Participants',
        dataField: 'malePercent',
        type: 'percent'
    },
    {
        colName: 'median-perc-male',
        colTitle: 'Median % Male Participants',
        dataField: 'maleMedianPercent',
        type: 'percent'
    },
    {
        colName: 'unknown-gender',
        colTitle: 'Participants of Unknown or Unreported Sex/Gender',
        dataField: 'unknownNotReportedGender',
        type: 'number'
    },
    {
        colName: 'perc-unknown-gender',
        colTitle: '%\u00A0Participants of Unknown or Unreported Sex/Gender',
        dataField: 'unknownNotReportedGenderPercent',
        type: 'percent'
    },
    {
        colName: 'median-perc-unknown-gender',
        colTitle: 'Median %\u00A0Participants of Unknown or Unreported Sex/Gender',
        dataField: 'unknownNotReportedGenderMedianPercent',
        type: 'percent'
    }
];

window.EthnicityColumns = [
    {
        colName: 'rcdc',
        colTitle: 'RCDC Category',
        dataField: 'rcdcCategory',
        type: 'string',
        display: false
    },
    {
        colName: 'institute',
        colTitle: 'Institute/Center',
        dataField: 'ic',
        type: 'string',
        display: false,
    },
    {
        colName: 'study-population',
        colTitle: '',
        dataField: 'studyPopulation',
        type: 'string',
        display: false
    },
    {
        colName: 'total',
        colTitle: 'Total Participants',
        dataField: 'totalEthnicityParticipants',
        type: 'number'
    },
    {
        colName: 'hispanic',
        colTitle: 'Hispanic or Latino Participants',
        dataField: 'hispanicLatino',
        type: 'number'
    },
    {
        colName: 'perc-hispanic',
        colTitle: '% Hispanic or Latino Participants',
        dataField: 'hispanicLatinoPercent',
        type: 'percent'
    },
    {
        colName: 'median-perc-hispanic',
        colTitle: 'Median % Hispanic or Latino Participants',
        dataField: 'hispanicLatinoMedianPercent',
        type: 'percent'
    },
    {
        colName: 'non-hispanic',
        colTitle: 'Not Hispanic or Latino Participants',
        dataField: 'notHispanicLatino',
        type: 'number'
    },
    {
        colName: 'perc-non-hispanic',
        colTitle: '% Not Hispanic or Latino Participants',
        dataField: 'notHispanicLatinoPercent',
        type: 'percent'
    },
    {
        colName: 'median-perc-non-hispanic',
        colTitle: 'Median % Not Hispanic or Latino Participants',
        dataField: 'notHispanicLatinoMedianPercent',
        type: 'percent'
    },
    {
        colName: 'unknown-ethinicity',
        colTitle: 'Participants of Unknown or Unreported Ethnicity',
        dataField: 'unknownNotReportedEthnicity',
        type: 'number'
    },
    {
        colName: 'perc-unknown-ethinicity',
        colTitle: '%\u00A0Participants of Unknown or Unreported Ethnicity',
        dataField: 'unknownNotReportedEthnicityPercent',
        type: 'percent'
    },
    {
        colName: 'median-perc-unknown-ethinicity',
        colTitle: 'Median %\u00A0Participants of Unknown or Unreported Ethnicity',
        dataField: 'unknownNotReportedEthnicityMedianPercent',
        type: 'percent'
    },
];

window.RaceColumns = [
    {
        colName: 'rcdc',
        colTitle: 'RCDC Category',
        dataField: 'rcdcCategory',
        type: 'string',
        display: false
    },
    {
        colName: 'institute',
        colTitle: 'Institute/Center',
        dataField: 'ic',
        type: 'string',
        display: false
    },
    {
        colName: 'study-population',
        colTitle: '',
        dataField: 'studyPopulation',
        type: 'string',
        display: false
    },
    {
        colName: 'total',
        colTitle: 'Total Participants',
        dataField: 'totalRaceParticipants',
        type: 'number'
    },

    {
        colName: 'native',
        colTitle: 'American Indian or Alaska Native Participants',
        dataField: 'nativeAmerican',
        type: 'number'
    },
    {
        colName: 'perc-native',
        colTitle: '% American Indian or Alaska Native Participants',
        dataField: 'nativeAmericanPercent',
        type: 'percent'
    },
    {
        colName: 'median-perc-native',
        colTitle: 'Median % American Indian or Alaska Native Participants',
        dataField: 'nativeAmericanMedianPercent',
        type: 'percent'
    },
    {
        colName: 'asian',
        colTitle: 'Asian Participants',
        dataField: 'asian',
        type: 'number'
    },
    {
        colName: 'perc-asian',
        colTitle: '% Asian Participants',
        dataField: 'asianPercent',
        type: 'percent'
    },
    {
        colName: 'median-perc-asian',
        colTitle: 'Median % Asian Participants',
        dataField: 'asianMedianPercent',
        type: 'percent'
    },
    {
        colName: 'hawaiian',
        colTitle: 'Native Hawaiian or Other Pacific Islander Participants',
        dataField: 'nativeHawaiianPacificIslander',
        type: 'number'
    },
    {
        colName: 'perc-hawaiian',
        colTitle: '% Native Hawaiian or Other Pacific Islander Participants',
        dataField: 'nativeHawaiianPacificIslanderPercent',
        type: 'percent'
    },
    {
        colName: 'median-perc-hawaiian',
        colTitle: 'Median % Native Hawaiian or Other Pacific Islander Participants',
        dataField: 'nativeHawaiianPacificIslanderMedianPercent',
        type: 'percent'
    },
    {
        colName: 'african',
        colTitle: 'Black or African American Participants',
        dataField: 'africanAmerican',
        type: 'number'
    },
    {
        colName: 'perc-african',
        colTitle: '% Black or African American Participants',
        dataField: 'africanAmericanPercent',
        type: 'percent'
    },
    {
        colName: 'median-perc-african',
        colTitle: 'Median % Black or African American Participants',
        dataField: 'africanAmericanMedianPercent',
        type: 'percent'
    },
    {
        colName: 'caucasian',
        colTitle: 'White Participants',
        dataField: 'white',
        type: 'number'
    },
    {
        colName: 'perc-caucasian',
        colTitle: '% White Participants',
        dataField: 'whitePercent',
        type: 'percent'
    },
    {
        colName: 'median-perc-caucasian',
        colTitle: 'Median % White Participants',
        dataField: 'whiteMedianPercent',
        type: 'percent'
    },
    {
        colName: 'multiracial',
        colTitle: 'Participants of More than One Race',
        dataField: 'multiracialParticipants',
        type: 'number'
    },
    {
        colName: 'perc-multiracial',
        colTitle: '% Participants of More than One Race',
        dataField: 'multiracialParticipantsPercent',
        type: 'percent'
    },
    {
        colName: 'median-perc-multiracial',
        colTitle: 'Median % Participants of More than One Race',
        dataField: 'multiracialParticipantsMedianPercent',
        type: 'percent'
    },
    {
        colName: 'unknown-race',
        colTitle: 'Participants of Unknown or Unreported Race',
        dataField: 'unknownNotReportedRace',
        type: 'number'
    },
    {
        colName: 'perc-unknown-race',
        colTitle: '%\u00A0Participants of Unknown or Unreported Race',
        dataField: 'unknownNotReportedRacePercent',
        type: 'percent'
    },
    {
        colName: 'median-perc-unknown-race',
        colTitle: 'Median %\u00A0Participants of Unknown or Unreported Race',
        dataField: 'unknownNotReportedRaceMedianPercent',
        type: 'percent'
    },
];
